"use client";

import { FC, ReactNode } from "react";
import ReactPaginate from "react-paginate";
import { useTranslations } from "next-intl";

import s from "./SearchPagination.module.scss";

interface Props {
  info?: ReactNode;
  pageCount: number;
  forcePage?: number;
  handlePageClick: (event: { selected: number }) => void;
}

export const SearchPagination: FC<Props> = ({ info, pageCount, forcePage, handlePageClick }) => {
  const t = useTranslations("search");

  return (
    <div className={s.PaginationWrapper}>
      {info && <div className={s.PaginationInfo}>{info}</div>}
      <ReactPaginate
        pageCount={pageCount}
        forcePage={forcePage}
        onPageChange={handlePageClick}
        previousLabel={t("pagination-previous")}
        nextLabel={t("pagination-next")}
        containerClassName={s.Pagination}
        className={s.Content}
        pageClassName={s.Page}
        pageLinkClassName={s.PageLink}
        previousLinkClassName={s.PagePrevious}
        nextLinkClassName={s.PageNext}
        disabledClassName={s.Disabled}
        breakClassName={s.Break}
      />
    </div>
  );
};
